import AccessSessionGroupListEmptyState from '@MyAccess/components/AccessSessionGroupListEmptyState';
import AccessSessionGroupListNoSearchResults from '@MyAccess/components/AccessSessionGroupListNoSearchResults';
import AccessSessionListSkeleton from '@MyAccess/components/AccessSessionListSkeleton';
import useAccessSessionGroups from '@MyAccess/hooks/use-access-session-groups';
import { AccessSessionGroupList } from '@MyAccess/organisms/AccessSessionGroupList';
import AccessSessionRequestModal from '@MyAccess/organisms/AccessSessionRequestModal';
import ConnectionMethodModal from '@MyAccess/organisms/ConnectionMethodModal';
import MyAccessFilters from '@MyAccess/organisms/filters/MyAccessFilters';
import { SearchBar } from '@common/components/SearchBar';
import { Loader } from '@common/ui/Loader';
import { Stack } from '@mui/material';

export default function MyAccessPage() {
  return (
    <>
      <MyAccessPageContent />
      <ConnectionMethodModal />
      <AccessSessionRequestModal />
    </>
  );
}

function MyAccessPageContent() {
  const {
    pageData,
    isFetched,
    isFetchingNextPage,
    handleOnPageChange,
    handleSearch,
    search,
    isFiltersOrSearchApplied,
  } = useAccessSessionGroups();

  const renderSearchBar = () => {
    if (pageData?.data.length !== 0 || isFiltersOrSearchApplied) {
      return (
        <Stack direction="row" spacing={2}>
          <SearchBar value={search} onChange={handleSearch} />
          <MyAccessFilters />
        </Stack>
      );
    }
    return null;
  };

  const renderSessionData = () => {
    if (!isFetched) return <Loader />;
    if (!isFetched && !search) return <AccessSessionListSkeleton />;
    if (!pageData || pageData.data.length === 0) {
      return isFiltersOrSearchApplied ? (
        <AccessSessionGroupListNoSearchResults />
      ) : (
        <AccessSessionGroupListEmptyState />
      );
    }
    return (
      <AccessSessionGroupList
        accessGroups={pageData.data}
        isLoading={isFetchingNextPage}
        pagination={pageData.pagination}
        onPageChange={handleOnPageChange}
      />
    );
  };

  return (
    <Stack spacing={2}>
      {renderSearchBar()}
      {renderSessionData()}
    </Stack>
  );
}
